<template>
  <button
    v-if="notification"
    type="button"
    class="block w-full cursor-pointer text-left transition-colors hover:bg-gray-50/80"
    @click="handleOpen"
  >
    <NotificationPreviewCard
      :notification="notification"
      :emphasize-unread="false"
      :reserve-close-space="true"
      :hide-time="true"
    />
  </button>

  <div v-else class="px-4 py-3.5">
    <p v-if="toast.title" class="text-h4 font-semibold text-gray-900">
      {{ toast.title }}
    </p>
    <p v-if="toast.description" class="mt-1 text-h5 text-gray-600">
      {{ toast.description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useToaster } from "@shopexperts/shared";
import NotificationPreviewCard from "@/v2Projects/components/NotificationPreviewCard.vue";
import type { DashboardNotification } from "@/v2Projects/types";

interface NotificationToastMeta {
  notification?: DashboardNotification;
  onOpen?: () => void | Promise<void>;
}

interface NotificationToastLike {
  id?: string;
  title?: unknown;
  description?: unknown;
  meta?: Record<string, unknown>;
}

const toaster = useToaster();

const props = defineProps<{
  toast: NotificationToastLike;
}>();

const notification = computed(() => {
  const candidate = (props.toast.meta as NotificationToastMeta | undefined)?.notification;
  return candidate ?? null;
});

function handleOpen() {
  if (props.toast.id) {
    toaster.dismiss(props.toast.id);
  }

  const onOpen = (props.toast.meta as NotificationToastMeta | undefined)?.onOpen;
  if (typeof onOpen === "function") {
    void onOpen();
  }
}
</script>
